import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../../Core/CommonV2/CustomModal";
import { CrossIcon } from "../../../Core/svgV2/CrossIcon";
import CustomButton from "../../../Core/CommonV2/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../Core/redux/hooks";
import {
  resetConversations,
  groupLeftAction,
} from "../../../Core/redux/slices/conversations.slice";
import { leaveGroup } from "../../../Core/redux/api/v3/conversationAPI";

const LeaveGroupModal = () => {
  const { leaveThread, leaveThreadDetails } = useAppSelector(
    (state) => state.conversations
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [leaving, setLeaving] = useState(false);

  const handleClose = () => {
    dispatch(resetConversations(["leaveThread", "leaveThreadDetails"]));
  };

  const handleLeaveGroup = async () => {
    if (leaving) return;
    setLeaving(true);
    try {
      const groupId = leaveThreadDetails.threadId;
      const result = await leaveGroup({ groupId });

      if (result) {
        dispatch(groupLeftAction({ groupId: String(groupId) }));
        dispatch(
          resetConversations([
            "showThreadProfileDrawer",
            "currentThread",
            "currentChatId",
            "leaveThread",
            "leaveThreadDetails",
          ])
        );
        navigate("/messages");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLeaving(false);
    }
  };

  return (
    <CustomModal
      visible={leaveThread}
      width="362px"
      onCancel={handleClose}
      body={
        <div className="p-4">
          <div className="flex justify-between">
            <p className="text-error-700 out-500-14">Leave group</p>
            <button onClick={handleClose}>
              <CrossIcon className="text-gray-700" />
            </button>
          </div>
          <p className="mt-4 out-300-14 text-gray-500 leading-5">
            Are you sure you want to leave this group? <br />
            This action cannot be undone.
          </p>
          <div className="flex mt-[21px] items-center gap-x-3 justify-end">
            <CustomButton
              text="Cancel"
              className="bg-transparent text-gray-500"
              height="30px"
              width="64px"
              onClick={handleClose}
              disabled={leaving}
            />
            <CustomButton
              text={leaving ? "Leaving..." : "Leave group"}
              height="30px"
              width="101px"
              className="bg-error-700 text-white"
              onClick={handleLeaveGroup}
              disabled={leaving}
            />
          </div>
        </div>
      }
    />
  );
};

export default LeaveGroupModal;